module.exports = __webpack_public_path__ + "img/768_stores_img5.45b93779.png";